export default __webpack_public_path__ + "static/media/arrow-right-citron-main.b68c52c6.svg";